// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDocumentOneTimeLinkDto
 */
export interface IDocumentOneTimeLinkDto {
    /**
     * 
     * @type {string}
     * @memberof IDocumentOneTimeLinkDto
     */
    hash_id: string;
    /**
     * 
     * @type {number}
     * @memberof IDocumentOneTimeLinkDto
     */
    employee_id: number;
    /**
     * 
     * @type {number}
     * @memberof IDocumentOneTimeLinkDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IDocumentOneTimeLinkDto
     */
    organization_path?: string;
}

/**
 * Check if a given object implements the IDocumentOneTimeLinkDto interface.
 */
export function instanceOfIDocumentOneTimeLinkDto(value: object): value is IDocumentOneTimeLinkDto {
    if (!('hash_id' in value) || value['hash_id'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    return true;
}

export function IDocumentOneTimeLinkDtoFromJSON(json: any): IDocumentOneTimeLinkDto {
    return IDocumentOneTimeLinkDtoFromJSONTyped(json, false);
}

export function IDocumentOneTimeLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDocumentOneTimeLinkDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hash_id': json['hash_id'],
        'employee_id': json['employee_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
    };
}

export function IDocumentOneTimeLinkDtoToJSON(json: any): IDocumentOneTimeLinkDto {
    return IDocumentOneTimeLinkDtoToJSONTyped(json, false);
}

export function IDocumentOneTimeLinkDtoToJSONTyped(value?: IDocumentOneTimeLinkDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hash_id': value['hash_id'],
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
    };
}

